export default __webpack_public_path__ + "static/assets/2d87300fabb15fd7c2ef59f9ca2fc921.jpg";